import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import classNames from 'classnames';
import { CSVImporter } from 'csv-import-react';
import PropTypes from 'prop-types';
import React, { useState, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '@panneau/element-button';
import Label from '@panneau/element-label';

var styles = {"container":"panneau-field-import-container","withoutModal":"panneau-field-import-withoutModal","disabled":"panneau-field-import-disabled"};

var propTypes = {
  // value: PropTypes.bool,
  // name: PropTypes.string,
  format: PropTypes.string,
  template: PropTypes.shape({
    columns: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string
    }))
  }),
  isModal: PropTypes.bool,
  icon: PropTypes.string,
  iconPosition: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  disabled: PropTypes.bool,
  theme: PropTypes.string,
  outline: PropTypes.bool,
  dark: PropTypes.bool,
  primaryColor: PropTypes.string,
  customStyles: PropTypes.shape({
    'color-background': PropTypes.string,
    'color-background-modal': PropTypes.string
  }),
  showDownloadTemplateButton: PropTypes.bool,
  skipHeaderRowSelection: PropTypes.bool,
  onChange: PropTypes.func,
  onClose: PropTypes.func,
  className: PropTypes.string
};
var defaultProps = {
  // value: null,
  // name: null,
  format: 'csv',
  template: null,
  isModal: false,
  icon: 'database',
  iconPosition: null,
  label: null,
  disabled: false,
  theme: 'primary',
  outline: false,
  dark: false,
  primaryColor: null,
  customStyles: null,
  showDownloadTemplateButton: true,
  skipHeaderRowSelection: false,
  onChange: null,
  onClose: null,
  className: null
};
var ImportField = function ImportField(_ref) {
  var format = _ref.format,
    isModal = _ref.isModal,
    icon = _ref.icon,
    iconPosition = _ref.iconPosition,
    label = _ref.label,
    template = _ref.template,
    disabled = _ref.disabled,
    theme = _ref.theme,
    outline = _ref.outline,
    dark = _ref.dark,
    primaryColor = _ref.primaryColor,
    customStyles = _ref.customStyles,
    showDownloadTemplateButton = _ref.showDownloadTemplateButton,
    skipHeaderRowSelection = _ref.skipHeaderRowSelection,
    onChange = _ref.onChange,
    onClose = _ref.onClose,
    className = _ref.className;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var openModal = useCallback(function () {
    setIsOpen(true);
  }, [onClose]);
  var finalOnClose = useCallback(function () {
    setIsOpen(false);
    if (onClose !== null) {
      onClose();
    }
  }, [onClose]);
  var onComplete = useCallback(function (data) {
    if (onChange !== null) {
      onChange(data);
    }
  }, [onChange]);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.container, _defineProperty(_defineProperty(_defineProperty({}, styles.withoutModal, !isModal), styles.disabled, disabled && !isModal), className, className !== null)])
  }, isModal ? /*#__PURE__*/React.createElement(Button, {
    type: "button",
    theme: theme,
    icon: icon || 'upload',
    iconPosition: iconPosition || 'right',
    onClick: openModal,
    disabled: isOpen || disabled,
    outline: outline
  }, /*#__PURE__*/React.createElement(Label, null, label || /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "z2775Q",
    defaultMessage: [{
      "type": 0,
      "value": "Import"
    }]
  }))) : null, format === 'csv' ? /*#__PURE__*/React.createElement(CSVImporter, {
    className: styles.importer,
    template: template,
    isModal: isModal,
    modalIsOpen: isOpen,
    modalOnCloseTriggered: finalOnClose,
    modalCloseOnOutsideClick: true,
    darkMode: theme === 'dark' || dark,
    primaryColor: primaryColor,
    customStyles: customStyles,
    onComplete: onComplete,
    showDownloadTemplateButton: showDownloadTemplateButton,
    skipHeaderRowSelection: skipHeaderRowSelection
  }) : null);
};
ImportField.propTypes = propTypes;
ImportField.defaultProps = defaultProps;

var definition = {
  id: 'import',
  component: 'Import'
};

export { ImportField as default, definition };
